import {MatPaginatorIntl} from '@angular/material/paginator';
import {Injectable} from '@angular/core';

@Injectable()
export class CustomPaginator extends MatPaginatorIntl {
  itemsPerPageLabel = 'Documents par page';
  nextPageLabel = 'Page suivante';
  previousPageLabel = 'Page précédente';
}
